/** Returns true only for a real YYYY-MM calendar month key. */
export function isValidMonthKey(value: string): boolean {
  if (!/^\d{4}-\d{2}$/.test(value)) return false;
  const [year, month] = value.split("-").map(Number);
  return year >= 1000 && month >= 1 && month <= 12;
}
